import React,{useState}  from 'react'
import {Box,Typography,Container,Button} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import AccountCircle from '@mui/icons-material/AccountCircle';
import ArrowIcon from '@mui/icons-material/ArrowBackRounded';
import CircularProgress from '@mui/material/CircularProgress';
import {IconButton} from "@mui/material"
import {useNavigate} from 'react-router-dom'
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import UserInput from '../Components/UserInput'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link'
import Snackbar from '@mui/material/Snackbar'
import GridViewContainer from '../Components/GridViewContainer';
import AutoInput from '../Components/AutoInput';
import MultiInput from '../Components/MultiInput';
import { add_pass } from '../Redux/passSlice';
import axios from 'axios';
import dayjs from 'dayjs';
import TimeInput from '../Components/TimeInput';
import DateInput from '../Components/DateInput';
import { MicRounded,FormatAlignCenter } from '@mui/icons-material';
import EditorText from '../Components/EditorText';

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'scroll',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
  },
  minHeight:600
})
);

function generate_id (){

	const c2 = Math.floor(Math.random()*10);
	const c3 = Math.floor(Math.random()*10);
	const c4 = Math.floor(Math.random()*10);
	const c1 = Math.floor(Math.random()*10);
	const c5 = Math.floor(Math.random()*10);
	const c6 = Math.floor(Math.random()*10);
	const c7 = Math.floor(Math.random()*10);
	const c8 = Math.floor(Math.random()*10);
  
	var result = `${c1}`+`${c2}`+`${c3}`+`${c4}`+`${c5}`+`${c6}`+`${c7}`+`${c8}`;
  
  return result
  }

const CreateTrain = ()=>{

	const response_types= ["Any(selection and True & False)","Selection(multiple or one choice)","True & False"]
	const levels = ["Beginner","Intermediate","Advanced","Expert"]
	const languages = ["French","English","Latino","Arabic","Bengali","Chinese","Spanish","German","Korean","Dutch","Hindi","Swahili","Japanese","Hebrew","Turkish","Portuguese","Russian"]

	const theme = useTheme()
	const [value,setValue] = useState(0)
	const [name,setName] = useState("")
	const [email,setEmail] = useState(null)
	const [description, setDescription] = useState("");
	const [describe, setDescribe] = useState("");
	const [questions, setQuestions] = useState("");
	const [duration, setDuration] = useState(0);
	const [start_date, setStart_date] = useState(null);
	const [start_moment, setStart_moment] = useState(null);
	const [level, setLevel] = useState("Advanced");
	const navigate = useNavigate()
	const [lang, setLang] = useState("French");
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [response_type, setResponse_type] = React.useState("Selection(multiple or one choice)");
	const [isInfo, setIsInfo] = React.useState(true);
	const [isPart, setIsPart] = React.useState(false);
	const [isSend, setIsSend] = React.useState(false);
	const [showDialog, setShowDialog] = React.useState(false);
	const [isNext, setIsNext] = React.useState(false);
	const [message, setMessage] = React.useState("");
	const [specialty, setSpecialty] = React.useState("");
	const [field, setField] = React.useState("");
	const [participants, setParticipants] = React.useState([]);
	const user = useSelector(state => state?.auth.user);
	const [isRecording, setIsRecording] = React.useState(null)
	const dispatch = useDispatch()

const handleCreate = async (e)=>{
    e?.preventDefault()
	try{
		if (isInfo) {
			if (name !== '' && description !== '' && level !== '' && lang !== '' && specialty !== '' && field !== '') {
				setIsInfo(false)
                setIsSend(true)
				setIsNext(true)
			} else {
				setMessage("please, fill all the form")
				setOpen(true)
			}
		} else{
			if (questions !== null && describe !== "" && response_type !== null && duration !== null) {
				

				const data = {
					id:generate_id(),
					name:name,
					email:user?.email,
					description:description,
					describe:describe,
					specialty:specialty,
					language:lang,
					field:field,
					questions:parseInt(questions),
					level:level,
					time:parseInt(duration),
					response_type:response_type,
					users:[
						{
							email:user?.email,
							last_name:user?.last_name,
							first_name:user?.first_name,
							hasTook:false,
							hasFinished:false,
							warning:null,
							isDisqualified:false,
							data:[]
						}
					]
				}

				// console.log(data)
				dispatch(add_pass({test:data,user:{
				    first_name:user?.first_name,
				    last_name:user?.last_name,
				    email:user?.email
				}}))
				
				navigate("/trainTest")
			
        } else {
            setMessage("please, fill all the form")
            setOpen(true)
        }
    }
}catch(err){
    console.log(err)
}
}

const handleSnackbarClose = ()=>{
	setOpen(false)
}

	return(
		<ContainerBox>
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography sx={{fontSize:12,color:"gray"}}>Create Test </Typography>
			</Breadcrumbs>			
			</Header>
			<Container sx={{marginLeft:-5}}>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
				<ContainerBox m={2} sx={{backgroundColor:"black",borderRadius:5,padding:2,width:'100%'}}>
					<Typography mt={1}  style={{fontSize:18,fontWeight:400,fontFamily:"dinofans"}}>
						Add Assessment Detail
					</Typography>
					<Box m={1} display="flex" width="90%" flexDirection="row" justifyContent="space-between" alignItems="center">
						<Typography mb={2} ml={3} style={{fontSize:16,color:"#ff0",fontFamily:"dinofans"}}>
							{
								isInfo ? "Assessment Info" : "Assessment Config"
							}
						</Typography>
						{
						isNext && (
							<IconButton sx={{borderRadius:2,height:25}} onClick={()=>{
								if(isSend){
									setIsSend(false)
                                    setIsNext(true)
                                    setIsInfo(true)
								}else{
                                    setIsSend(true)
                                    setIsNext(false)
                                    setIsInfo(false)
								}
								
							}}>
								<ArrowIcon />
							</IconButton>
						)}
					</Box>
					{
					isInfo && (
						<GridViewContainer>
							<UserInput
								label="Title *"
								isPass={false}
								input={name}
								setInput={setName}
							>
								<FormatAlignCenter/>
							</UserInput>
							<AutoInput
								data={languages}
								setInput={setLang}
								input={lang}
								label="language"
							/>
							<UserInput
								label="Field *"
								input={field}
								isDes={false}
								isPass={false}
								setInput={setField}
							>
								<FormatAlignCenter/>
							</UserInput>
							<UserInput
								label="specialty *"
								input={specialty}
								isPass={false}
								isDes={false}
								setInput={setSpecialty}
							>
								<FormatAlignCenter/>
							</UserInput>
							<AutoInput
								data={levels}
								setInput={setLevel}
								input={level}
								label="level"
							/>
							<Box width="100%">
								<EditorText 
									title="Assessment description"
									data={description}
									setData={setDescription}
									width="95%"
									label="description"
									isRequired={true}
								/>
							</Box>
						</GridViewContainer>
						)
					}
					{
					isSend && (
						<GridViewContainer>
							<UserInput
								label="Duration *"
								input={duration}
								isDate={false}
								isPass={false}
								setInput={setDuration}
							>
								<AccountCircle/>
							</UserInput>
							<AutoInput
								data={response_types}
								setInput={setResponse_type}
								input={response_type}
								label="response type"
							/>
							<UserInput
								label="Questions *"
								isPass={false}
								input={questions}
								setInput={setQuestions}
							>
								<FormatAlignCenter/>
							</UserInput>
							<Box width="95%">
								<EditorText 
									title="Questions description"
									data={describe}
									setData={setDescribe}
									width="95%"
									label="description"
									isRequired={true}
								/>
							</Box>
						</GridViewContainer>
					)}
                    <Box >
                        <Button disabled={loading} onClick={handleCreate} color="primary" variant="contained" sx={{mt:2}}>
                            {
                                isSend && loading ? <CircularProgress size={20} style={{color:"gold"}}/> : isSend && !loading  ? "PASS" : "NEXT"
                            }
                        </Button>
                    </Box>
				</ContainerBox>
				<CustomDialog handleUserDelete={(email)=>{
					const filterData = participants?.filter(item=>item?.email !== email)
					setParticipants(filterData)
				}} data={participants} visible={showDialog} setVisible={setShowDialog}/>
			</Container>
		</ContainerBox>
		)
}

export default CreateTrain